import IRequiredDocumentDetailType from "./IRequiredDocumentDetailType";
import RequiredDocumentDetailTypeCode from "@/module/main/dto/RequiredDocumentDetailTypeCodeEnum";

export class RequiredDocumentDetailType implements IRequiredDocumentDetailType
{
    constructor(
        public code: RequiredDocumentDetailTypeCode
    )
    {
    }
}
